export default __webpack_public_path__ + "static/media/PR.0ba77892.png";